import { useMutation } from "@apollo/client/react/hooks";
import { useEffect } from "react";
import {
  REFRESH_TOKEN_USER_SESSION,
  RefreshTokenOperationInput,
  RefreshTokenOperationResponse,
} from "../../components/auth/queries/auth-management/auth-management-queries";
import {
  completeRefreshToken,
  completeUserLogout,
  getTokenFromNativeStorage,
  refreshTokenCheckProgress,
} from "../../utils/helpers/auth-helper";
import { LoadStatus } from "../../utils/types/component-configs";

export default function TokenManager() {
  const [refreshToken, { client }] = useMutation<
    RefreshTokenOperationResponse,
    RefreshTokenOperationInput
  >(REFRESH_TOKEN_USER_SESSION);

  useEffect(() => {
    async function beginTokenRefresh() {
      refreshTokenCheckProgress({ status: LoadStatus.PROGRESS });
      const { refreshToken: savedRefreshToken } = getTokenFromNativeStorage();
      if (!savedRefreshToken) {
        refreshTokenCheckProgress({ status: LoadStatus.SUCCESS });
        return;
      }

      try {
        const result = await refreshToken({
          variables: {
            sessionData: { refreshToken: savedRefreshToken },
          },
          fetchPolicy: "no-cache",
          errorPolicy: "all",
        });
        if (!result?.data?.refreshToken) {
          completeUserLogout(client, { autoLogout: true });
          refreshTokenCheckProgress({ status: LoadStatus.ERROR });
          return;
        }
        completeRefreshToken(result.data.refreshToken);
        refreshTokenCheckProgress({ status: LoadStatus.SUCCESS });
      } catch (refreshTokenError) {
        completeUserLogout(client, { autoLogout: true });
        refreshTokenCheckProgress({ status: LoadStatus.ERROR });
      }
    }
    const intervalId = window.setInterval(
      () => beginTokenRefresh(),
      Number(process.env.AUTH_TOKEN_TIMEOUT)
    );

    // Do it the first time to instantly load the token
    beginTokenRefresh();

    return () => {
      window.clearInterval(intervalId);
    };
  }, [refreshToken]);

  return null;
}
